module.exports = __webpack_public_path__ + "media/images/redesign-images/contract/contract-sales-05-6fb4b9da4027f3d0fe160af22a6e3098.svg";